/**
 * Falsy-string / empty-trim coalescing without `||` (Sonar typescript:S6606).
 * Skips null, undefined, and '' — same behavior as `a || b` for strings.
 */

export function firstNonEmpty(
  ...values: ReadonlyArray<string | null | undefined>
): string | undefined {
  for (const value of values) {
    if (value != null && value !== '') {
      return value;
    }
  }
  return undefined;
}

export function firstNonEmptyOr(
  fallback: string,
  ...values: ReadonlyArray<string | null | undefined>
): string {
  return firstNonEmpty(...values) ?? fallback;
}

/** Trim each candidate, then take the first non-empty result. */
export function firstNonEmptyTrimmed(
  ...values: ReadonlyArray<string | null | undefined>
): string | undefined {
  for (const value of values) {
    const trimmed = value?.trim();
    if (trimmed) {
      return trimmed;
    }
  }
  return undefined;
}

export function firstNonEmptyTrimmedOr(
  fallback: string,
  ...values: ReadonlyArray<string | null | undefined>
): string {
  return firstNonEmptyTrimmed(...values) ?? fallback;
}

/** Treat 0 / null / undefined as missing (same as `n || fallback` for numbers). */
export function positiveNumberOr(
  value: number | null | undefined,
  fallback: number
): number {
  return value != null && value !== 0 ? value : fallback;
}
